<template>
  <div :class="layoutClass.formGroupRowClass">
    <div
      v-if="label"
      :id="`wrapper-label${id}`"
      :class="layoutClass.labelWrapperClass"
      >
      <label
        :for="id"
        :class="layoutClass.labelClass"
        >
          {{label}}
        </label>
    </div>
    <div :class="layoutClass.flatPickrWrapperClass">
      <flat-pickr
        v-model="date"
        :config="config"
        :class="[{'is-invalid': v ? v.$error : false},layoutClass.flatPickrClass]"
        :placeholder="placeholder"
        :id="id"
        readonly="false"
        :maxDate="maxDate"
        ></flat-pickr>
      <p class="invalid-feedback" v-if=" v ? !v.required : false"> {{ $t('field_required') }} </p>
    </div>
    <div class="input-group-append">
      <button class="btn btn-default input-group-text" type="button" title="Clear" @click="date = null">
        <font-awesome-icon icon="times"/>
      </button>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Spanish } from 'flatpickr/dist/l10n/es.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
library.add(faTimes)

export default {
  props: {
    value: {
      type: String,
      default: null
    },
    v: {
      type: Object
    },
    minDate: {
      type: [String, Date]
    },
    maxDate: {
      type: Date
    },
    config: {
      type: Object,
      default: function () {
        return {
          dateFormat: 'j-m-Y',
          locale: Spanish,
          allowInput: true
        }
      }
    },
    label: String,
    placeholder: String,
    id: {
      type: String,
      required: true
    },
    layout: {
      type: Array,
      required: true
      // Options form-group input-group
    }
  },
  components: {
    flatPickr
  },
  computed: {
    date: {
      get () {
        return this.value
      },
      set (value) {
        if (this.v) {
          this.v.$touch()
        }
        this.$emit('input', value)
      }
    },
    layoutClass () {
      switch (this.layout[0]) {
        case 'form-group':
          return {
            formGroupRowClass: ['form-group', 'row'],
            labelWrapperClass: ['col-sm-2'],
            labelClass: ['col-form-label'],
            flatPickrWrapperClass: ['col-sm-10'],
            flatPickrClass: ['form-control']
          }
        case 'input-group':
          return {
            formGroupRowClass: ['input-group', this.layout[1]],
            labelWrapperClass: ['input-group-prepend'],
            labelClass: ['input-group-text'],
            flatPickrWrapperClass: ['flex-100'],
            flatPickrClass: ['form-control', 'custom-select']
          }
        default:
          return null
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  .flex-100
    flex: 1 0 0
    width: 1%
  .form-control:disabled,
  .form-control[readonly]
    background-color: white
</style>

/* TODO:
5 Ver de crear un sólo componente en vez de tener dos LmDate y LmDateTime
3 La primera fecha seleccionable de dateTime.from debe ser la fecha más vieja del registro.
4 La última fecha seleccionable de dateTime.from debe ser la fecha más actual del registro.
*Mientras se trae la data de la api para configurar los inputs el input tiene que permanecer disable y de ser posible motrar un loading.
7 Crear una validación para la props layout
8 Probar su funcionamiento en mobile
9 Layout deberia poder recibir un string o un objecto como valor en caso que sea un objecto va a poder definir las clases de cada propiedad de layoutClass, esto se haria en la sección default del switch
*/
